// The icon for what starts a workflow or a run: a workflow's `trigger` or a run's
// `trigger_detail`, both tagged by `kind`.
import { Clock, HandTap, Ticket, Timer } from "@phosphor-icons/react";

import { parseTrigger } from "./policy";

export function TriggerIcon({ trigger, className }: { trigger: unknown; className?: string }) {
  switch (parseTrigger(trigger).kind) {
    case "cron":
      return <Clock weight="duotone" className={className} />;
    case "interval":
      return <Timer weight="duotone" className={className} />;
    case "ticket":
      return <Ticket weight="duotone" className={className} />;
    case "manual":
    case "unknown":
      return <HandTap weight="duotone" className={className} />;
  }
}
